import React, { Component } from 'react';
import { connect } from 'react-redux';
import './index.scss';
import CommonDialog from '../../common/dialog/index';
import { actionCreators } from './store';

class Details extends Component {

  constructor(props) {
    super(props);

    this.state = {
      id: '',
      type: '',
      title: ''
    }
  }

  componentDidMount() {
    const { fetchDetailsData } = this.props;
    const id = this.props.location.state.id;
    const type = this.props.location.state.type;
    const title = this.props.location.state.title;

    this.setState({ id, type, title }, () => {
      fetchDetailsData(type, { id: id });
    });
  }

  render() {

    const { details } = this.props;
    const { id, type, title } = this.state;
    const dialogData = {
      id, type, title, status: details.get('status')
    }

    // console.log('dialogData', dialogData);/

    return (
      <div className="details">
        <div className="details__wrap">
          <h1 className="details__title">
            <span className="label">{details.get('domain')}</span>
            <p className="text">{details.get('name')}</p>
          </h1>

          {
            details.get('domain') ? (
              <div className="details__desc">
                <span className="head">需求领域：</span>
                <p className="text">{details.get('domain')}</p>
              </div>
            ) : null
          }

          {
            details.get('patent') ? (
              <div className="details__desc">
                <span className="head">专利情况：</span>
                <p className="text">{details.get('patent')}</p>
              </div>
            ) : null
          }

          {
            details.get('operation') ? (
              <div className="details__desc">
                <span className="head">合作需求：</span>
                <p className="text">{details.get('operation')}</p>
              </div>
            ) : null
          }

          {
            details.get('number') ? (
              <div className="details__desc">
                <span className="head">专利号/登记号/品种权号/成果编号：</span>
                <p className="text"> {details.get('number')}</p>
              </div>
            ) : null
          }

          {
            details.get('type') ? (
              <div className="details__desc">
                <span className="head">需求类型：</span>
                <p className="text">{details.get('type')}</p>
              </div>
            ) : null
          }

          {
            details.get('maturity') ? (
              <div className="details__desc">
                <span className="head">技术/成果成熟度：</span>
                <p className="text">{details.get('maturity')}</p>
              </div>
            ) : null
          }

          {
            details.get('file') ? (
              <div className="details__desc block">
                <span className="head">成果图片：</span>
                <div className="details__img-box">
                  {
                    details.get('file').map((item, index) => {
                      return (
                        <img className="pic" key={index} src={item} alt=""></img>
                      )
                    })
                  }
                </div>
              </div>
            ) : null
          }

          {
            details.get('span') ? (
              <div className="details__desc">
                <span className="head box">关键词：</span>
                <ul className="details__label-box">
                  {
                    details.get('span').map((item, index) => {
                      return (
                        <li className="details__label-item" key={index}>{item}</li>
                      )
                    })
                  }
                </ul>
              </div>
            ) : null
          }


          {
            details.get('account') ? (
              <div className="details__desc">
                <span className="head">技术/成果简介：</span>
                <p className="text">{details.get('account')}</p>
              </div>
            ) : null
          }

          {
            details.get('des') ? (
              <div className="details__desc">
                <span className="head">技术/成果描述：</span>
                <p className="text">{details.get('des')}</p>
              </div>
            ) : null
          }

          {
            details.get('innovation') ? (
              <div className="details__desc">
                <span className="head">优势和创新：</span>
                <p className="text">{details.get('innovation')}</p>
              </div>
            ) : null
          }

          {
            details.get('application') ? (
              <div className="details__desc">
                <span className="head">场景应用：</span>
                <p className="text">{details.get('application')}</p>
              </div>
            ) : null
          }

          {
            details.get('team') ? (
              <div className="details__desc">
                <span className="head">研发团队：</span>
                <p className="text"> {details.get('team')}</p>
              </div>
            ) : null
          }

          <CommonDialog dialogData={dialogData}></CommonDialog>
        </div>
      </div>
    )
  }
}

const mapState = (state) => ({
  details: state.getIn(['details', 'details'])
});

const mapDispatch = (dispatch) => ({
  fetchDetailsData(flag, obj) {
    dispatch(actionCreators.fetchDetailsData(flag, obj))
  }
});

export default connect(mapState, mapDispatch)(Details);
